// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__26_sL","box":"WorkspacesBox_box__2FSMy","node":"WorkspacesBox_node__3Jb2m"};